import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import projet from './modules/projet'
import alert from './modules/alert'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
      auth,
      projet,
      alert,
    },
})
